import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class EntityExistsFail extends UploadFail {
    static WEB_BACKEND_ERROR = 'CONDITION/ENTITYEXISTS';

    radarName = 'fail_{SOURCE}entity-exists';

    message = 'Сущность с таким именем уже существует.';
}
